import { colorTokens, colorHelpersFor, colors as colors$1 } from '@hover/blueprint-theme';

function toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

// NOTE: we need to implement `ColorHues` for each palette in
// order for Chakra to consider a palette as a `colorScheme`

// For backward compatibility with legacy Blueprint color theme structure
// (e.g: `colors.primary500` instead of Chakra-style `colors.primary[500]`)
var legacyColors = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, colorTokens), {}, {
  neutral000: colorTokens.neutral0
});
var defineColors = function defineColors(colors) {
  var palettes = {
    primary: colors.primary,
    secondary: _objectSpread2({
      50: colors.secondary[100]
    }, colors.secondary),
    success: colors.success,
    warning: colors.warning,
    danger: colors.danger,
    neutral: colors.neutral,
    info: colors.primary,
    brandNavy: _objectSpread2({
      50: colors.brandNavy[100]
    }, colors.brandNavy),
    brandGreen: _objectSpread2({
      50: colors.brandGreen[100]
    }, colors.brandGreen),
    brandBrown: _objectSpread2({
      50: colors.brandBrown[100]
    }, colors.brandBrown),
    brandRed: _objectSpread2({
      50: colors.brandRed[100]
    }, colors.brandRed),
    brandTan: _objectSpread2({
      50: colors.brandTan[100]
    }, colors.brandTan),
    brandOrange: _objectSpread2({
      50: colors.brandOrange[100]
    }, colors.brandOrange),
    brandYellow: _objectSpread2({
      50: colors.brandYellow[100]
    }, colors.brandYellow),
    brandPurple: _objectSpread2({
      50: colors.brandPurple[100]
    }, colors.brandPurple),
    darkAlpha: colors.darkAlpha,
    lightAlpha: colors.lightAlpha
  };
  var allColors = _objectSpread2(_objectSpread2({}, palettes), {}, {
    blue: palettes.primary,
    green: palettes.brandGreen,
    orange: palettes.brandOrange,
    purple: palettes.brandPurple,
    red: palettes.brandRed,
    yellow: palettes.brandYellow,
    halo: colors.halo,
    ring: colors.ring,
    border: colors.border
  }, legacyColors);
  return _objectSpread2(_objectSpread2({}, allColors), colorHelpersFor(colors));
};
var colors = /*#__PURE__*/defineColors(colors$1);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

export { _objectSpread2 as _, _slicedToArray as a, _objectWithoutProperties as b, _arrayLikeToArray as c, defineColors as d, _unsupportedIterableToArray as e, _defineProperty as f, colors as g, legacyColors as l };
